// api/booking.service.js
import API from './axiosConfig';  // ✅ Sirf API import karo, axios nahi chahiye

// No need for getAuthHeaders - API interceptor automatically adds token

/**
 * Get client commission percentage
 * GET /api/client-commission/:client_id
 */
export const getClientCommission = async (clientId) => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.get(`/api/client-commission/${clientId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching client commission:', error);
    throw error;
  }
};

/**
 * Calculate quotation (without saving)
 * POST /api/calculate-quotation
 */
export const calculateQuotation = async (quotationData) => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.post('/api/calculate-quotation', quotationData);
    return response.data;
  } catch (error) {
    console.error('Error calculating quotation:', error);
    throw error;
  }
};

/**
 * Create booking and send quotation
 * POST /api/create-booking-and-send-quotation
 */
export const createBookingAndSendQuotation = async (bookingData) => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.post('/api/create-booking-and-send-quotation', bookingData);
    return response.data;
  } catch (error) {
    console.error('Error creating booking and sending quotation:', error);
    throw error;
  }
};

/**
 * Send quotation email only (for existing bookings)
 * POST /api/send-quotation
 */
export const sendQuotation = async (quotationData) => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.post('/api/send-quotation', quotationData);
    return response.data;
  } catch (error) {
    console.error('Error sending quotation:', error);
    throw error;
  }
};

/**
 * Get all bookings for a client
 * GET /api/bookings
 */
export const getBookings = async () => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.get('/api/bookings');
    return response.data;
  } catch (error) {
    console.error('Error fetching bookings:', error);
    throw error;
  }
};

/**
 * Get single booking with details
 * GET /api/bookings/:id
 */
export const getBookingDetails = async (id) => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.get(`/api/bookings/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching booking details:', error);
    throw error;
  }
};

/**
 * UPDATE QUOTATION - Update existing booking and send updated email
 * PUT /api/bookings/:id
 */
export const updateQuotationAndSendEmail = async (id, data) => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.put(`/api/bookings/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating quotation:', error);
    throw error;
  }
};

/**
 * GET QUOTATION FOR EDIT - Get booking details for editing
 * GET /api/bookings/:id/edit
 */
export const getQuotationForEdit = async (id) => {
  try {
    // ✅ FIXED: Direct API call
    const response = await API.get(`/api/bookings/${id}/edit`);
    return response.data;
  } catch (error) {
    console.error('Error fetching quotation for edit:', error);
    throw error;
  }
};